export default class {
    static error(text) {
        alert(text);
    }
    static success(text) {
        alert(text);
    }
};
